/**
 * Unauthenticated Apollo Client for Cognito Auth Operations
 *
 * This is a simple Apollo Client used exclusively for authentication-related
 * GraphQL mutations that don't require an access token. It's used by the
 * CognitoAuthProvider to avoid circular dependency issues with the main
 * AuthApolloProvider.
 */

import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';

/**
 * Create a simple Apollo Client for unauthenticated requests
 * Used only for Cognito authentication operations
 * @returns A configured Apollo Client for auth operations
 */
export const createUnauthApolloClient = () => {
  const httpLink = new HttpLink({
    uri: `${import.meta.env?.VITE_GRAPHQL_URL || '/'}api/graphql`,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'network-only',
      },
      query: {
        fetchPolicy: 'network-only',
      },
      mutate: {
        fetchPolicy: 'network-only',
      },
    },
  });
};
